import React from 'react';
import Box from "@mui/material/Box";

const CardAno = (params) => {
    const ano = params.ano;
    const dados = params.dados;
    const baseUrl = process.env.REACT_APP_API_URL || window.location.origin;

  return (
    <div>
        <h3>{ano}</h3>
          <Box className="transparencia_list">
          {Object.entries(dados).map(([key, value]) => (
              <div className="balancete_item" key={key}>
                <p><a className='transparencia_link' href={`${baseUrl}/api${value.url}`}>{value.nome}</a></p>
              </div>
          ))}
        </Box>
    </div>
  );
};

export default CardAno;

